/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./NewPassword.css";

class NewPassword extends Component {
  render() {
    return (
      <div className="NewPassword-view">
        <div className="NewPassword-bg"></div>

        <div className="NewPassword-main">
          <div className="NewPassword-header">
            <a href="/ChangePassword">
              <div className="NewPassword-back">
                <div className="NewPassword-backBtn"></div>
                <div className="NewPassword-backText">返回</div>
              </div>
            </a>

            <div className="NewPassword-headingText">更改密碼</div>
          </div>

          <div className="NewPassword-fieldbtn">
            <div className="NewPassword-inputFieldContainer">
              <input
                type="password"
                className="NewPassword-inputField"
                placeholder="新密碼"
              />
            </div>

            <a href="/rePassword">
              <div className="NewPassword-nextBtn">下一步</div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default NewPassword;
